<template>
  <v-container grid-list-md>
    <v-row dense class="flex-column mb-10">
      <v-col cols="12">
        <span class="display-1 font-weight-light">{{ course.name }}</span>
        <action-button type="back" @click="$router.go(-1)" class="float-right" />
      </v-col>
    </v-row>

    <div v-if="enrolments.length > 0">
      <v-row dense>
        <!-- ENROLLED -->
        <v-col cols="12">
          <p class="headline font-weight-light mb-1">{{ $t("checkin.enrolled") }} ({{ enrolments.length }})</p>
          <hr />
        </v-col>
        <v-col cols="4" v-for="item in enrolments" :key="item.id">
          <v-card color="primary" dark @click="checkin(item.id)">
            <v-card-text>
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="headline">
                    {{ item.first_name }}<br />
                    {{ item.last_name }}
                  </v-card-title>

                  <v-card-title class="caption py-0"
                    >Birthday: {{ item.date_of_birth ? moment.utc(item.date_of_birth).format(DATE_FORMAT) : "N/A" }}</v-card-title
                  >
                </div>

                <v-avatar class="ma-3" size="125" tile>
                  <v-img :src="item.image_url ? item.image_url : require('@/assets/img/no-image.jpg')" aspect-ratio="1"> </v-img>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-row dense>
      <!-- ATTENDEES -->
      <v-col cols="12" class="mt-8">
        <p class="headline font-weight-light mb-1">{{ $t("checkin.attendees") }} ({{ attendees.length }})</p>
        <hr />
      </v-col>
      <v-col cols="4" v-for="item in attendees" :key="item.id">
        <v-card color="primary" dark>
          <v-card-text>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">
                  {{ item.participant.first_name }}<br />
                  {{ item.participant.last_name }}
                </v-card-title>

                <v-card-title class="caption py-0"
                  >Birthday:
                  {{
                    item.participant.date_of_birth ? moment.utc(item.participant.date_of_birth).format(DATE_FORMAT) : "N/A"
                  }}</v-card-title
                >
              </div>

              <v-avatar class="ma-3" size="125" tile>
                <v-img :src="item.participant_image ? item.participant_image : require('@/assets/img/no-image.jpg')"> </v-img>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- DID NOT MEET -->
      <v-col cols="12" class="mt-8">
        <p class="headline font-weight-light mb-1">{{ $t("checkin.did_not_meet") }} ({{ did_not_meets.length }})</p>
        <hr />
      </v-col>
      <v-col cols="4" v-for="item in did_not_meets" :key="item.id">
        <v-card color="primary" dark @click="checkin(item.id)">
          <v-card-text>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">
                  {{ item.first_name }}<br />
                  {{ item.last_name }}
                </v-card-title>

                <v-card-title class="caption py-0"
                  >Birthday: {{ item.date_of_birth ? moment.utc(item.date_of_birth).format(DATE_FORMAT) : "N/A" }}</v-card-title
                >
              </div>

              <v-avatar class="ma-3" size="125" tile>
                <v-img :src="item.image_url ? item.image_url : require('@/assets/img/no-image.jpg')"> </v-img>
              </v-avatar>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "checkinList",

  props: ["id"],

  data() {
    return {
      course: {},
      attendees: [],
      enrolments: [],
      did_not_meets: []
    }
  },

  created() {
    this.loadCourse()
  },

  methods: {
    loadCourse() {
      axios.get(this.API_URL + "course/" + this.id).then((res) => {
        this.course = res.data.data

        if (this.course.id) {
          let lists = [
            { key: "attendees", module: "attendees", query: "show_all=true&query_course_id=" + this.course.id },
            { key: "enrolments", module: "enrolments", query: "show_all=true&query_course_id=" + this.course.id + "&query_status=1" },
            { key: "did_not_meets", module: "enrolments", query: "show_all=true&query_course_id=" + this.course.id + "&query_status=2" }
          ]

          axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
            this.attendees = res.data.attendees
            this.enrolments = res.data.enrolments
            this.did_not_meets = res.data.did_not_meets
          })
        }
      })
    },

    checkin(id) {
      this.$router.push(this.BACKEND_URL + "/checkin/enrol/" + this.course.id + "/" + id)
    }
  }
}
</script>

<style>
.custom-banner .v-banner__wrapper {
  padding-left: 0;
}
</style>
